webpackJsonp([218316416206443],{

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(24);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _axios = __webpack_require__(11);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FaqsEn = function (_Component) {
	  _inherits(FaqsEn, _Component);
	
	  function FaqsEn(props) {
	    _classCallCheck(this, FaqsEn);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      loading: true
	    };
	    _this.handleToogle = _this.handleToogle.bind(_this);
	    _this.renderFaqs = _this.renderFaqs.bind(_this);
	    return _this;
	  }
	
	  FaqsEn.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _axios2.default.get(_config.backendURL + '/api/faqs').then(function (res) {
	      _this2.setState({
	        loading: false,
	        faqs: res.data
	      });
	      _axios2.default.get(_config.backendURL + '/api/banners/page/Faqs').then(function (res) {
	        var main = res.data.filter(function (data) {
	          return data.section === 'Main';
	        });
	        if (main[0]) {
	          _this2.setState(function (prevState) {
	            return _extends({}, prevState, {
	              loading: false,
	              mainImageEn: {
	                title: main[0].title.en,
	                url: main[0].imageEn
	              }
	            });
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    });
	  };
	
	  FaqsEn.prototype.handleToogle = function handleToogle(e) {
	    var _setState;
	
	    var _e$target = e.target,
	        value = _e$target.checked,
	        id = _e$target.id;
	
	    this.setState((_setState = {}, _setState[id] = value, _setState));
	  };
	
	  FaqsEn.prototype.renderFaqs = function renderFaqs() {
	    var _this3 = this;
	
	    var faqs = this.state.faqs;
	
	    return _.map(faqs, function (faq, i) {
	      var title = faq.title,
	          description = faq.description,
	          published = faq.published;
	      var lang = _this3.props.pathContext.langKey;
	
	      if (published) {
	        var id = 'faq' + i;
	        return _react2.default.createElement(
	          'div',
	          { className: !_this3.state[id] ? 'item on' : 'item off' },
	          _react2.default.createElement('input', { type: 'checkbox', id: id, onClick: _this3.handleToogle }),
	          _react2.default.createElement(
	            'label',
	            { 'for': id },
	            title[lang]
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'excerpt' },
	            description[lang]
	          )
	        );
	        return null;
	      }
	    });
	  };
	
	  FaqsEn.prototype.render = function render() {
	    if (this.state.loading) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'page faqs' },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Budget Nicaragua FAQs',
	        meta: [{
	          name: 'description',
	          content: 'Frequently Asked Questions about car rentals.'
	        }],
	        link: [{
	          rel: 'alternate',
	          hreflang: 'en',
	          href: './es/faqs'
	        }]
	      }),
	      this.state.mainImageEn ? _react2.default.createElement('img', {
	        src: '' + _config.backendURL + this.state.mainImageEn.url,
	        alt: this.state.mainImageEn.title,
	        style: { width: '100%' },
	        className: 'top-bg'
	      }) : _react2.default.createElement('div', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'FAQ'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In Budget Rent a Car we are always at your disposal for any doubt or query you have, then some questions and answers or if you want to contact us in the icon of CONTACT US to consult personally.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'accordion' },
	          this.renderFaqs()
	        )
	      )
	    );
	  };
	
	  return FaqsEn;
	}(_react.Component);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = FaqsEn;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faqs-en-js-a6eee950cbe9041d4dde.js